const darkThemeData = {
  colors: {
    primaryColor: '#5678ff',
    secondaryColor: '#0B1132',
    black: '#F7F7F7',
    primaryTextColor: '#F7F7F7',
    secondaryTextColor: '#F7F7F7',
    error: '#F80E38',
    success: '#2DF90B',
    gray: '#9B9EAB' + '59',
    yellow: '#fbe51f',
    primaryHoverColor: '#4563d9',
    primaryHoverTextColor: '#0B1132',
    secondaryHoverColor: 'rgba(86, 120, 255, 0.1)',
    secondaryHoverTextColor: '#040D2D',
    backgroundColor: '#0B1132',
    secondaryBackgroundColor: '#080C22',
    tretiaryBackgroundColor: '#0E163C',
    plainBackgroundColor: '#0E163C',
    mainWhite: '#F7F7F7',
    status: {
      blue: '#0B78F9',
      purple: '#1E0BF9',
      magenta: '#900BF9',
      pink: '#F90BB6',
      red: '#F90B0B',
    },
  },
  palette: {
    primary: {
      main: '#5678ff',
      light: '#819aff',
      dark: '#4563d9',
      contrastText: '#0B1132',
    },
    secondary: {
      main: '#0B1132',
      light: '#819aff',
      dark: '#4563d9',
      contrastText: '#040D2D',
  
    },
    error: {
      main: '#F80E38',
      light: '#f75b77',
      dark: '#af0b29',
      contrastText: '#F7F7F7',
    },
    success: {
      main: '#2DF90B',
      light: '#84ff6e',
      dark: '#27b90d',
      contrastText: '#F7F7F7',
    },
    warning: {
      main: '#fbe51f',
      light: '#ffee59',
      dark: '#c4b218',
      contrastText: '#F7F7F7',
    },
    info: {
      main: '#c9ccda',
      light: '#9B9EAB',
      dark: '#848485',
      contrastText: '#040D2D',
    },
    text: {
      primary: '#F7F7F7',
      secondary: '#9B9EAB',
    },
  },
  typography: {
    'fontFamily': 'Mulish',
    'fontSize': 14,
    'letterSpacing': 1,
    'color': '#F7F7F7',
  },
};

export default darkThemeData;